<template>
  <article class="project project-ga" ref="mandala-page">
    <main class="padded">
      <section class="project-ga__section">
        <h1>Generative Art</h1>
        <p>
          Generative art is a form of art which is, in part or full, created by
          an autonomous system. Autonomous system can be any kind of algorithm:
          mathematical, mechanical, or biological.
        </p>
      </section>

      <section class="project-ga__section project-ga__figures">
        <img
          src="/assets/images/projects/GenArt/circle_packing.png"
          alt="Generative Circle Packing"
          class="project-ga__figure"
        />
        <video controls width="250" class="project-ga__figure">
          <source
            src="/assets/images/projects/GenArt/gen.webm"
            type="video/webm"
            alt="Generative Equation Tracking"
          />

          Sorry, your browser doesn't support embedded videos.
        </video>

        <img
          src="/assets/images/projects/GenArt/mandala.png"
          alt="Generative Mandala"
          class="project-ga__figure"
        />
      </section>
      <section class="project-ga__section">
        <p>
          More on
          <a
            href="https://codepen.io/collection/AWeBBj"
            target="_blank"
            rel="noopener noreferrer"
            >Codepen</a
          >
        </p>
      </section>
    </main>
    <section class=" project-ga__sketch sketch">
      <p class="padded">
        Create your own generative art - Drag anywhere on the canvas below to
        create a mandala
      </p>
      <div class="sketch-controls">
        <div class="sketch-controls__slider">
          <label for="mirrors">Mirrors</label>
          <input
            type="range"
            id="mirrors"
            name="mirrors"
            min="4"
            max="24"
            v-model="mirrors"
          />
        </div>
        <button @click="p5.refresh()">Clear Canvas</button>
        <button @click="p5.download()">Download Image</button>
      </div>
      <div class="project-ga__mandala" id="mandala" ref="mandala-canvas"></div>
    </section>
  </article>
</template>

<script>
import P5 from 'p5'
export default {
  data() {
    return {
      mirrors: 12,
      p5: null
    }
  },
  methods: {
    getSize: function() {
      return Math.min(
        this.$refs['mandala-canvas'].parentElement.clientWidth * 0.9,
        this.$refs['mandala-canvas'].parentElement.clientHeight
      )
    },
    createCanvas: function() {
      let size = this.getSize()

      let id = this.$refs['mandala-canvas'].id

      const sketch = s => {
        let pmx, pmy, cmx, cmy, angle, turns, coff

        s.setup = () => {
          let canvas = s.createCanvas(size, size)
          s.colorMode(s.HSB, 360, 100, 100)
          coff = s.random(360)
          s.strokeWeight(3)
          s.background('#222')
        }
        s.refresh = () => {
          s.background('#222')
        }
        s.draw = () => {
          turns = this.mirrors

          let c = coff % 360
          angle = s.TWO_PI / turns
          s.translate(size / 2, size / 2)
          cmx = s.mouseX - size / 2
          cmy = s.mouseY - size / 2
          pmx = s.pmouseX - size / 2
          pmy = s.pmouseY - size / 2

          s.stroke(c, 60, 100)
          s.strokeWeight(s.random(1, 6))

          for (let i = 0; i < s.TWO_PI; i += angle) {
            s.rotate(angle)

            if (
              s.mouseIsPressed &&
              s.mouseX > 0 &&
              s.mouseX < size &&
              s.mouseY < size &&
              s.mouseY > 0
            ) {
              s.push()
              s.line(cmx, cmy, pmx, pmy)
              s.pop()
              s.push()
              s.scale(1, -1)
              s.line(cmx, cmy, pmx, pmy)
              s.pop()
            }
          }
          coff++
        }

        s.windowResized = () => {
          let size = this.getSize()
          s.resizeCanvas(size, size)
          s.background('#222')
        }
        s.download = () => {
          s.saveCanvas('generativeMandala', 'png')
        }
      }

      this.p5 = new P5(sketch, id)
    }
  },
  mounted: function() {
    this.$nextTick(() => {
      this.createCanvas()
    })
  }
}
</script>

<style scoped>
.project-ga__section {
  //width: 100%;
}
.project-ga__figures {
  width: 80%;
  margin: 1.2rem auto;
  padding: 0;
}
.project-ga__figure {
  margin-bottom: var(--padding-sm);
}
.project-ga__sketch {
  width: 100%;
  height: 99vh;
  display: grid;
  place-items: center;
  margin: 0;
  position: relative;
}

.sketch-controls {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.sketch-controls > * {
  margin: 0.8rem;
}
.sketch-controls__slider {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.project-ga__mandala {
  padding: 0;
  margin: 0;
  border: 0.4rem solid var(--bg-color);
  touch-action: none;
}
@media only screen and (min-width: 60rem) {
  .project-ga__figures {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1.2rem;
  }
  .project-ga__sketch {
    width: calc(100vw - 20px - 1rem - 19.2rem);
  }
}
</style>
